import getStars from '../../../utils/getStars';

const templateTrainingGroup = (hasOwner, slots, players) => slots.filter(item => item.nft_id).map((slot, index) => {
  const player = players.filter(player => player.name).find(item => item.id === slot.nft_id);
  return `
    <div class="started-player js-go-to-detail d-flex align-items-start flex-column">
      <div class="started-player__label ${index === 0 ? 'started-player__label--active' : ''} d-flex align-items-center" for="player-${player?.id}">
        <div class="started-player__image" style="background-image: url(${player?.thumbnail});"> </div>
        ${hasOwner ? `<div class="started-player__countdown js-countdown" id="js-countdown-${index}" data-type="single" data-id="${player?.id}" data-generation="${player?.generation}" data-start-date="${ slot.started_at}" data-end-date="${slot.end_date}"></div>` : ''}
      </div>
      <div class="started-player__content">
      <div class="started-player__name">${getStars(player?.star)}</div>
      <div class="started-player__name">${player?.name}</div>
        <div class="started-player__id">#${player?.id}</div>
      </div>
    </div>
  `;
}).join('');

export default templateTrainingGroup;
